import { apiClient } from './apiClient';

function computeSubtotal(items) {
  return (items || []).reduce((sum, item) => {
    const qty = Number(item.quantity) || 0;
    const price = Number(item.price) || 0;
    return sum + qty * price;
  }, 0);
}

export function computeTotals(order) {
  const subtotal = computeSubtotal(order.items || []);
  const discount = Math.max(0, Number(order.discount) || 0);
  const total = Math.max(0, subtotal - discount);
  return { subtotal, discount, total };
}

export async function getAll(params = {}) {
  const response = await apiClient.get('/orders', params);
  return response;
}

export async function getById(id) {
  const response = await apiClient.get(`/orders/${id}`);
  return response.data || null;
}

export async function create(order) {
  const response = await apiClient.post('/orders', order);
  return response.data;
}

export async function update(id, data) {
  const response = await apiClient.put(`/orders/${id}`, data);
  return response.data;
}

export async function remove(id) {
  await apiClient.del(`/orders/${id}`);
}

export default { getAll, getById, create, update, remove, computeTotals };
